import { object, string } from 'yup';
import { AxiosPromise, AxiosResponse } from 'axios';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { type } from 'os';
import config from '@/config/index';

type TipoInformeBackend = {
  id?: number;
  descripcion?: string;
};
export type TipoInforme = {
  id?: number;
  descripcion?: string;
};

type GetHttpResponseBody = unknown;

const axios = new AxiosVue(ServicioProxy.Reporte);

const makeHttpRequest = (): AxiosPromise<GetHttpResponseBody> => {
  return axios.http.get('Reporte/TipoInforme');
};

const getResponseData = (
  axiosResponse: AxiosResponse<GetHttpResponseBody>
): TipoInformeBackend[] => {
  try {
    const tipos = axiosResponse.data;
    return tipos instanceof Array ? tipos : [];
  } catch {
    return [];
  }
};

function getSubDomain(): string {
  //let url: string = "http://qa-betterfield.gpschile.com/";
  //let url: string = "https://track3.gpschile.com/tracker";
  let url: string = window.location.href;
  // Utilizamos una expresión regular para extraer el subdominio de la URL
  var subdominio = url.match(/^(?:https?:\/\/)?([^/.]+)/i);

  // Si se encontró un subdominio, lo retornamos
  if (subdominio && subdominio.length > 1) {
    return subdominio[1].split(':')[0];
  } else {
    return ''; // No se encontró un subdominio
  }
}

const schema = object({
  id: string().ensure(),
  descripcion: string().ensure(),
});

const getMaybeValidTipoInforme = (
  tipoInforme: TipoInformeBackend
): Promise<TipoInformeBackend | null> => {
  let clienteId: number = config.getClienteSesion();
  // Perfilación cliente
  if (clienteId != 16414 && tipoInforme.id == 16) {
    return null;
  }
  if (clienteId != 3798 && tipoInforme.id == 20) {
    return null;
  }
  if (clienteId != 2892 && tipoInforme.id == 21) {
    return null;
  }
  if (clienteId != 3833 && (tipoInforme.id == 24 || tipoInforme.id == 25)) {
    return null;
  }
  if (
    clienteId != 2735 &&
    (tipoInforme.id == 30 || tipoInforme.id == 31 || tipoInforme.id == 32)
  ) {
    return null;
  }
  if (clienteId != 3123 && tipoInforme.id == 27) {
    return null;
  }
  if (clienteId != 2852 && tipoInforme.id == 29) {
    return null;
  }

  // Validar si está parado en el canal gpschile
  let isTrack: boolean = [
    'gpstrack',
    'track3',
    'qagpstrack',
    'localhost',
    'track3s3',
  ].includes(getSubDomain());

  // Lista de informes a excluir para canales diferentes a gpschile
  let excludedList: number[] = [6, 7, 11, 15, 16, 17, 18, 20, 21, 24, 25];

  if (!isTrack && excludedList.includes(tipoInforme.id)) {
    return null;
  }

  return schema
    .isValid(tipoInforme, {
      strict: false,
      stripUnknown: true,
    })
    .then(valid => (valid ? tipoInforme : null));
};

const parseTipoInforme = (x: TipoInformeBackend): TipoInforme => ({
  id: x.id,
  descripcion: x.descripcion,
});

export const fetchTipoInforme = () =>
  makeHttpRequest()
    .then(getResponseData)
    .then(
      (TipoInforme): Promise<Array<TipoInformeBackend | null>> =>
        Promise.all(TipoInforme.map(getMaybeValidTipoInforme))
    )
    .then(TipoInforme => TipoInforme.filter(x => x))
    .then(TipoInforme => TipoInforme.map(parseTipoInforme));
